import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import useUniqueId from '../../../util/useUniqueId.js';
import '../Common/index.js';
import '../InputFrame/index.js';
import { InputFrame as InputFrameMemo } from '../InputFrame/InputFrame.js';
import { ButtonInputSkeleton as ButtonInputSkeletonMemoized } from '../Common/ButtonInputSkeleton.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getFrameProps = function getFrameProps(props) {
  var label = props.label,
    state = props.state,
    intent = props.intent,
    helperText = props.helperText,
    labelId = props.labelId,
    helperTextId = props.helperTextId;
  return {
    showLabel: !!label,
    component: 'dropdown',
    state: state !== null && state !== void 0 ? state : 'enabled',
    label: label,
    intent: intent !== null && intent !== void 0 ? intent : 'default',
    flex: 1,
    helperText: helperText,
    labelId: labelId,
    helperTextId: helperTextId
  };
};
var getButtonProps = function getButtonProps(props) {
  var id = props.id,
    value = props.value,
    placeholder = props.placeholder,
    state = props.state,
    leadingAsset = props.leadingAsset,
    labelId = props.labelId,
    helperTextId = props.helperTextId,
    onBlur = props.onBlur,
    onClick = props.onClick,
    onDragStart = props.onDragStart,
    onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    onMouseDown = props.onMouseDown,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    onPointerDown = props.onPointerDown,
    onPointerEnter = props.onPointerEnter,
    onPointerLeave = props.onPointerLeave,
    onPointerUp = props.onPointerUp,
    ariaHasPopup = props['aria-haspopup'],
    ariaExpanded = props['aria-expanded'],
    dataElementName = props['data-element-name'],
    ariaLabel = props['aria-label'],
    ariaLabelledBy = props['aria-labelledby'];
  return {
    id: id,
    value: value,
    state: state,
    placeholder: placeholder,
    leadingAsset: leadingAsset,
    trailingAsset: {
      id: 'line.arrow.thin-dropdown'
    },
    onBlur: onBlur,
    onClick: onClick,
    onDragStart: onDragStart,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onPointerDown: onPointerDown,
    onPointerEnter: onPointerEnter,
    onPointerLeave: onPointerLeave,
    onPointerUp: onPointerUp,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy || labelId,
    'aria-describedby': helperTextId,
    'aria-haspopup': ariaHasPopup,
    'aria-expanded': ariaExpanded,
    'data-element-name': dataElementName
  };
};
var DropdownTrigger = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var helperTextId = useUniqueId();
  var labelId = useUniqueId();
  return /*#__PURE__*/React.createElement(InputFrameMemo, _extends({}, getFrameProps(_objectSpread(_objectSpread({}, props), {}, {
    labelId: labelId,
    helperTextId: helperTextId
  })), {
    ref: props.containerRef
  }), /*#__PURE__*/React.createElement(ButtonInputSkeletonMemoized, _extends({
    ref: ref
  }, getButtonProps(_objectSpread(_objectSpread({}, props), {}, {
    labelId: labelId,
    helperTextId: helperTextId
  })))));
});
var DropdownTriggerMemo = /*#__PURE__*/React.memo(DropdownTrigger);

export { DropdownTriggerMemo as DropdownTrigger };
//# sourceMappingURL=DropdownTrigger.js.map
